module.exports = __webpack_public_path__ + "img/select.f13c0137.svg";